/**
 * @file 获取举报策略
 * @see http://api.umucdn.cn/project/46/interface/api/4751
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

import { REPORT_TYPE, REPORT_CATEGORY_TYPE } from '@umu/umu-types';

export interface IInput {
    kind: REPORT_TYPE;
}

export interface IOption {
    id: string;
    txt: string;
}

export interface ICategory {
    name: string;
    category: REPORT_CATEGORY_TYPE;
    kind: REPORT_TYPE;
}

export interface IOutput {
    kinds: {
        kind: REPORT_TYPE;
        options: IOption[];
    };
    category: ICategory[];
}

export const getReportPolicy = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.REPORT_POLICY, data);
};
